import assets from "app/assets";
import { Container, DEG_TO_RAD, Sprite } from "pixi.js";
import tools from "tools";
export default class Flame extends Container {
  constructor() {
    super();
    tools.autobind(this);
    this._init();
  }
  _init() {
    this.flame0 = new Sprite(assets.textures.flame.texture);
    this.flame0.anchor.x = .5;
    this.flame0.anchor.y = 1;
    this.flame0.scale.x = .5;
    this.flame0.scale.y = 1;
    this.flame0.alpha = .8;
    this.flame1 = new Sprite(assets.textures.flame.texture);
    this.flame1.anchor.x = .5;
    this.flame1.anchor.y = 1;
    this.flame1.scale.x = .4;
    this.flame1.scale.y = 1.2;
    this.flame2 = new Sprite(assets.textures.flame.texture);
    this.flame2.anchor.x = .5;
    this.flame2.anchor.y = 1;
    this.flame2.scale.x = .7;
    this.flame2.scale.y = .7;
    this.flame2.alpha = .8;
    this.addChild(this.flame0);
    this.addChild(this.flame1);
    this.addChild(this.flame2);
    this.visible = false;
  }
  play() {
    this.interval && clearInterval(this.interval);
    this.interval2 && clearInterval(this.interval2);
    this.interval = setInterval(() => {
      this.flame0.rotation = tools.range(-10, 10) * DEG_TO_RAD;
      this.flame1.rotation = tools.range(-15, 15) * DEG_TO_RAD;
      this.flame2.rotation = tools.range(-25, 25) * DEG_TO_RAD;
    }, 80);
    this.interval2 = setInterval(() => {
      this.flame0.visible = Math.random() > .3 ? true : false;
      this.flame1.visible = Math.random() > .3 ? true : false;
      this.flame2.visible = Math.random() > .3 ? true : false;
    }, 30);
  }
  stop() {
    this.interval && clearInterval(this.interval);
    this.interval2 && clearInterval(this.interval2);
  }
}
